module.exports = {"name":"subscribeToWatchOrFollow","audiences":["allMembers"],"experimentAllocation":1,"defaultWeight":0,"experimentVersion":"v1","defaults":{"enabled":false},"variations":[{"name":"watch","weight":1},{"name":"follow","weight":0}],"autoTrack":true}


//////////////////
// WEBPACK FOOTER
// ./app/scripts/lib/experiments/config/subscribeToWatchOrFollow.json
// module id = tORg
// module chunks = 2